import { atom } from 'jotai'
import { API_CACHE_DURATION, urls } from '../constants'
import { GetRequestCachedV3, PostRequest } from '../api'
import { alertAtom, globalLoaderAtom } from './globalStateAtoms'

export const getCompaniesListAllForMTPLMasterData = atom([])
export const fetchCompaniesListAllAtoms = atom(null, async (get, set, data) => {
  try {
    set(globalLoaderAtom, true)
    const res = await PostRequest(urls.getCompaniesListAll, data)
    if (res.status === 'Success') {
      set(getCompaniesListAllForMTPLMasterData, res.Data)
    } else {
      set(getCompaniesListAllForMTPLMasterData, [])
      set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server' })
    }
  } catch (error) {
    console.error(error)
    set(getCompaniesListAllForMTPLMasterData, [])
  } finally {
    set(globalLoaderAtom, false)
  }
})
export const getCargoSettingData = atom([])
export const fetchCargoSettingAtoms = atom(null, async (get, set, data) => {
  try {
    set(globalLoaderAtom, true)
    const res = await PostRequest(urls.getCargoSetting, data)
    if (res.status === 'Success') {
      set(getCargoSettingData, res.Data[0])
    } else {
      set(getCargoSettingData, [])
      set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server' })
    }
  } catch (error) {
    console.error(error)
    set(getCargoSettingData, [])
  } finally {
    set(globalLoaderAtom, false)
  }
})

export const userListForLuggageSettingUpdateAtom = atom([])
export const fetchUserListForLuggageSettingUpdateAtom = atom(null, async (get, set) => {
  try {
    const res = await GetRequestCachedV3(urls.userListForLuggageSettingUpdate, {}, true, API_CACHE_DURATION)
    if (res.status === 'Success') {
      set(userListForLuggageSettingUpdateAtom, res.Data.Table)
    } else {
      set(userListForLuggageSettingUpdateAtom, [])
      set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server' })
    }
  } catch (error) {
    console.error(error)
    set(userListForLuggageSettingUpdateAtom, [])
  } finally {
  }
})